import LeadDirectoryList from './LeadDirectoryList'
import LeadDirectoryCreate from './LeadDirectoryCreate'
import LeadDirectoryEdit from './LeadDirectoryEdit'
import LeadDirectoryShow from './LeadDirectoryShow'
import FolderIcon from '@mui/icons-material/Folder'

const lead_directories = {
  list: LeadDirectoryList,
  create: LeadDirectoryCreate,
  edit: LeadDirectoryEdit,
  show: LeadDirectoryShow,
  icon: FolderIcon,
}

export default lead_directories
